import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken, getZipCodeGeoCoordinates } from '@/redux/modules/account/user/user.selectors';
import { getIsBot } from '@/redux/modules/analytics';
import { getClientIpAddress } from '@/redux/modules/browser';
import { getDeployment } from '@/redux/modules/config';
import { getUserExcludedFacets } from '@/redux/modules/search/exclusions/searchExclusions.selectors';
import { fetchSearchResults } from '@/redux/modules/search/search.api';
import { getAugmentedSearchQuery } from '@/redux/modules/search/search.helpers';
import { isErrorResponse } from '@/redux/modules/search/search.types';
import { buildSearchQuery } from '@/utils/search/searchQuery';

import { ARTICLE_RELATED_ITEMS_LIMIT, FetchArticleRelatedItemsParams } from './articleRelatedItems.types';

export const fetchArticleRelatedItems = createAsyncThunk<number[], FetchArticleRelatedItemsParams>(
    'la/ui/articleRelatedItems/fetchArticleRelatedItems',
    async ({ keyword }, { getState }) => {
        const trimmed = keyword.trim();
        if (!trimmed) {
            return [];
        }

        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const ipAddress = getClientIpAddress(state);
        const isBot = getIsBot(state);

        const searchQuery = buildSearchQuery({
            queryParams: { keyword: trimmed },
            searchPageSize: ARTICLE_RELATED_ITEMS_LIMIT,
        });

        const searchExclusions = getUserExcludedFacets(state);
        const augmentedSearchQuery = getAugmentedSearchQuery(
            { ...(isBot ? { isBot } : {}), ...searchQuery },
            searchExclusions
        );

        const results = await fetchSearchResults({
            authToken,
            deployment,
            geoCoordinates: getZipCodeGeoCoordinates(state),
            ipAddress,
            searchQuery: augmentedSearchQuery,
            useGeoLocation: false,
        });

        if (isErrorResponse(results)) {
            return [];
        }

        return results.payload.itemIDs.slice(0, ARTICLE_RELATED_ITEMS_LIMIT);
    }
);
